module.exports = __webpack_public_path__ + "static/img/bg_sales_detail.395cc72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_sales_detail.png
// module id = DmNC
// module chunks = 192